export default "__VITE_ASSET__iMqkTbDR__"